import { useMemo } from "react"

import { UniquePrices } from "../interfaces/UniquePrices"
import { getPrices } from "../components/Card/utils"

import { Psychologist } from "utils/interfaces"
import { uniq } from "utils/infrastructure"

export function useGetUniquePrices(psy?: Psychologist): UniquePrices {
    return useMemo(() => {
        if (psy?.offered_services === undefined) {
            return { uniquePrices: [] }
        }

        const prices = getPrices(psy.offered_services)
        const uniquePrices = uniq(prices)
        return { uniquePrices }
    }, [psy])
}
